import { GetPlantOverviewResponse } from '@/features/plants/hooks/queries/[plantId]/use-get-plant-overview.ts';
import style from './plant-production-and-storage-environmental-benefits.module.scss';
import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import { cn } from '@/utils/utils.ts';

export const PlantProductionAndStorageEnvironmentalBenefits = ({
  overview,
  isLoading,
  className,
}: {
  overview: GetPlantOverviewResponse | undefined | null;
  isLoading: boolean;
  className?: string;
}) => {
  return (
    <DashboardCard
      className={cn(style.environmental_benefits, 'h-full min-h-[148px] w-full', className)}
      isLoading={isLoading}
    >
      <>
        <h3 className="font-semibold text-nowrap">Environmental benefits</h3>
        <div className="flex gap-4">
          <div className="flex w-full flex-col gap-2 rounded-lg bg-[#DBFF0020] p-3">
            <span className="text-[#7D7D85]">CO2 emission saved</span>
            <span className="text-2xl font-semibold text-nowrap">
              {overview?.environmentalBenefits?.co2Reduction}{' '}
              <span className="text-muted-foreground text-xl">kg</span>
            </span>
          </div>
          <div className="flex w-full flex-col gap-2 rounded-lg bg-[#73FF8120] p-3">
            <span className="text-nowrap text-[#7D7D85]">Equivalent trees planted</span>
            <span className="text-2xl font-semibold text-nowrap">
              {Math.trunc(overview?.environmentalBenefits?.treesPlanted ?? 0)}
            </span>
          </div>
          <div className="flex w-full flex-col gap-2 rounded-lg bg-[#0055FF20] p-3">
            <span className="text-nowrap text-[#7D7D85]">Standard coal saved</span>

            <span className="text-2xl font-semibold text-nowrap">
              {overview?.environmentalBenefits?.coalSavedTons}{' '}
              <span className="text-muted-foreground text-xl">t</span>
            </span>
          </div>
        </div>
      </>
    </DashboardCard>
  );
};
